import React, { useState, useEffect } from 'react'
import axios from 'axios'
import {
	Box,
	Card,
	CardContent,
	Grid,
	Typography,
	ToggleButton,
	ToggleButtonGroup,
	useMediaQuery,
	Dialog,
	DialogTitle,
	DialogContent,
	ButtonGroup,
	Button,
	TextField,
	OutlinedInput,
	FormControl,
	IconButton
} from '@material-ui/core'
import {
	FirstPage as FirstPageIcon,
	LastPage as LastPageIcon,
	ChevronLeft as ChevronLeftIcon,
	ChevronRight as ChevronRightIcon,
	SearchOutlined,
	Close
} from '@material-ui/icons'
import Technicalassessment from './Technicalassessment'
import { useGetAssessmentsQuery } from 'hooks/useApollo'
import { useGlobalWebSocket } from 'context/WebSocketContext'
import useIntl from 'hooks/useIntl'
import { makeStyles, useTheme } from '@material-ui/core/styles'
import { DataTablePagination } from './TablePagination'
interface FlexOneProps {
	assessId: string
}
type Applicant = {
	id: string
	name: string
	// Add other fields as necessary
}

const useStyles = makeStyles(() => ({
	noScroll: {
		overflowY: 'scroll',
		scrollbarWidth: 'none',
		'-ms-overflow-style': 'none',
		'&::-webkit-scrollbar': {
			display: 'none'
		}
	}
}))
const FlexOne = ({ assessId }: FlexOneProps) => {
	const [applicantsData, setApplicantsData] = useState<any[]>([])
	const [loading, setLoading] = useState(false)
	const intl = useIntl()
	const [selectedFilter, setSelectedFilter] = useState('today')
	const [openDialog, setOpenDialog] = useState(false)
	const [applicantsCache, setApplicantsCache] = useState<Record<string, any[]>>({})
	const [selectedApplicant, setSelectedApplicant] = useState<any>(null)
	const classes = useStyles()

	const { registerRefetch } = useGlobalWebSocket()
	const [filteredApplicants, setFilteredApplicants] = useState<Applicant[]>([])
	const [page, setPage] = useState(1)
	const [limit, setLimit] = useState(10)
	const [totalPages, setTotalPages] = useState(0)
	const [totalRecords, setTotalRecords] = useState(0)
	const [searchTerm, setSearchTerm] = useState('')
	const isMobile = useMediaQuery('(max-width:600px)')
	const theme = useTheme()
	const [searchQuery, setSearchQuery] = useState('')
	const handleFilterChange = value => setSelectedFilter(value)

	const [filtering, setFiltering] = useState(false) // NEW

	const getProgressColor = (progress: number) => {
		if (progress < 50) return '#ff6f61'
		if (progress < 80) return '#7D6EF1'
		return 'rgb(0, 196, 140)'
	}

	const { data, refetch } = useGetAssessmentsQuery({
		variables: { lastActive: localStorage.getItem('lastActive') }
	})

	const handlePageChange = (newPage: number) => {
		setPage(newPage)
	}

	const handlePageSizeChange = (newLimit: number) => {
		setLimit(newLimit)
		setPage(1)
	}

	// useEffect(() => {
	// 	if (assessId) {
	// 		fetchApplicants()
	// 	}
	// }, [page, selectedFilter, assessId])
	useEffect(() => {
		if (assessId) {
			fetchApplicants()
		}
	}, [page, selectedFilter, assessId, limit])

	// const fetchApplicants = async () => {
	// 	try {
	// 		const response = await axios.post(
	// 			`${process.env.REACT_APP_API_URL}/api/v1/sandbox/getApplicantsbyTeam`,
	// 			{
	// 				assessId,
	// 				filter: selectedFilter,
	// 				page,
	// 				limit
	// 			},
	// 			{
	// 				headers: { 'Content-Type': 'application/json' }
	// 			}
	// 		)

	// 		const { data, totalPages, totalRecords } = response.data

	// 		setApplicantsData(data)
	// 		setTotalPages(totalPages || Math.ceil(totalRecords / limit))
	// 		setTotalRecords(totalRecords)
	// 	} catch (error) {
	// 		console.error('Error fetching applicants:', error)
	// 	}
	// }
	// const fetchApplicants = async () => {
	// 	try {
	// 		const response = await axios.post(
	// 			`${process.env.REACT_APP_API_URL}/api/v1/sandbox/getApplicantsbyTeam`,
	// 			{
	// 				assessId,
	// 				filter: selectedFilter,
	// 				page,
	// 				limit
	// 			},
	// 			{
	// 				headers: { 'Content-Type': 'application/json' }
	// 			}
	// 		)

	// 		const { data, totalPages, totalRecords } = response.data

	// 		setApplicantsData(data)
	// 		setTotalPages(totalPages || Math.ceil(totalRecords / limit))
	// 		setTotalRecords(totalRecords)
	// 	} catch (error) {
	// 		console.error('Error fetching applicants:', error)
	// 	}
	// }
	const fetchApplicants = async () => {
		try {
			setFiltering(true) // Start loading

			const response = await axios.post(
				`${process.env.REACT_APP_API_URL}/api/v1/sandbox/getApplicantsbyTeam`,
				{
					assessId,
					filter: selectedFilter,
					page,
					limit
				},
				{
					headers: { 'Content-Type': 'application/json' }
				}
			)

			const { data, totalPages, totalRecords } = response.data

			setApplicantsData(data)
			setTotalPages(totalPages || Math.ceil(totalRecords / limit))
			setTotalRecords(totalRecords)
		} catch (error) {
			console.error('Error fetching applicants:', error)
		} finally {
			setFiltering(false) // Done loading
		}
	}

	useEffect(() => {
		const unregister = registerRefetch(() => {
			refetch()
			fetchApplicants()
		})
		return () => unregister()
	}, [registerRefetch, refetch, assessId, selectedFilter])

	const handleCardClick = (applicant: any) => {
		setSelectedApplicant(applicant)
		setOpenDialog(true)
	}

	const handleCloseDialog = () => {
		setOpenDialog(false)
	}

	useEffect(() => {
		if (searchQuery.trim() === '') {
			setFilteredApplicants(applicantsData)
		} else {
			const filtered = applicantsData.filter(applicant => {
				const fullName = `${applicant.firstName} ${applicant.lastName}`.toLowerCase()
				return fullName.includes(searchQuery.toLowerCase())
			})
			setFilteredApplicants(filtered)
		}
	}, [searchQuery, applicantsData])

	const filteredApplicantss = applicantsData.filter(applicant => {
		const fullName = `${applicant.firstName || ''} ${applicant.lastName || ''}`
		return fullName.toLowerCase().includes(searchQuery.trim().toLowerCase())
	})

	return (
		<div>
			<Box display="flex" justifyContent="space-between" mb={2} gap={2}>
				<div>
					<FormControl sx={{ width: { xs: '100%', md: 400 } }}>
						<OutlinedInput
							value={searchQuery}
							onChange={e => setSearchQuery(e.target.value)}
							size="small"
							placeholder="Search all columns..."
							id="header-search"
							startAdornment={
								<Box sx={{ display: 'flex', alignItems: 'center', pl: 1 }}>
									<SearchOutlined />
								</Box>
							}
							aria-describedby="header-search-text"
							inputProps={{ 'aria-label': 'search' }}
						/>
					</FormControl>
				</div>

				<DataTablePagination
					page={page}
					totalPages={totalPages}
					limit={limit}
					onPageChange={handlePageChange}
					onPageSizeChange={handlePageSizeChange}
					totalRecords={totalRecords}
				/>
			</Box>

			<Box
				style={{
					display: 'flex',
					flexDirection: 'row',
					alignItems: 'center'
				}}
			>
				<Typography variant="body1" style={{ flexGrow: 1, fontWeight: 'bold' }}>
					{intl.formatMessage({ id: 'Recent Assessment' })}
				</Typography>
				<Typography
					variant="body1"
					style={{ flexGrow: 1, fontWeight: 'bold', marginRight: '10px' }}
				>
					{intl.formatMessage({ id: 'Time Taken' })}
				</Typography>
				<Typography
					variant="body1"
					style={{ flexGrow: 1, fontWeight: 'bold', marginRight: '1px' }}
				>
					{intl.formatMessage({ id: 'Exam Taken On' })}
				</Typography>

				<div style={{ display: 'flex', height: '32px' }}>
					<div
						onClick={() => handleFilterChange('today')}
						style={{
							cursor: 'pointer',
							minWidth: '30px',
							fontSize: '0.75rem',
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
							padding: '5px',
							borderRadius: '4px 0px 0px 4px',
							border: '1px solid #ffffff',
							backgroundColor:
								selectedFilter === 'today'
									? theme.palette.primary.main
									: theme.palette.grey[100],
							color: selectedFilter === 'today' ? theme.palette.common.white : 'black',
							textAlign: 'center'
						}}
						onMouseEnter={e => {
							e.currentTarget.style.backgroundColor = theme.palette.primary.main
							e.currentTarget.style.color = theme.palette.common.white
						}}
						onMouseLeave={e => {
							e.currentTarget.style.backgroundColor =
								selectedFilter === 'today'
									? theme.palette.primary.main
									: theme.palette.grey[100]
							e.currentTarget.style.color =
								selectedFilter === 'today' ? theme.palette.common.white : 'black'
						}}
					>
						Today
					</div>

					<div
						onClick={() => handleFilterChange('last7days')}
						style={{
							cursor: 'pointer',
							minWidth: '30px',
							fontSize: '0.75rem',
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
							padding: '5px',
							borderRadius: '0px',
							border: `1px solid ${theme.palette.common.white}`,
							backgroundColor:
								selectedFilter === 'last7days'
									? theme.palette.primary.main
									: theme.palette.grey[100],
							color: selectedFilter === 'last7days' ? theme.palette.common.white : 'black'
						}}
						onMouseEnter={e => {
							e.currentTarget.style.backgroundColor = theme.palette.primary.main
							e.currentTarget.style.color = theme.palette.common.white
						}}
						onMouseLeave={e => {
							e.currentTarget.style.backgroundColor =
								selectedFilter === 'last7days'
									? theme.palette.primary.main
									: theme.palette.grey[100]
							e.currentTarget.style.color =
								selectedFilter === 'last7days' ? theme.palette.common.white : 'black'
						}}
					>
						Last 7 Days
					</div>
					<div
						onClick={() => handleFilterChange('last30days')}
						style={{
							cursor: 'pointer',
							minWidth: '30px',
							fontSize: '0.75rem',
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
							padding: '5px',
							borderRadius: '0px 4px 4px 0px',
							border: '1px solid #ffffff',
							backgroundColor:
								selectedFilter === 'last30days'
									? theme.palette.primary.main
									: theme.palette.grey[100],
							color: selectedFilter === 'last30days' ? theme.palette.common.white : 'black'
						}}
						onMouseEnter={e => {
							e.currentTarget.style.backgroundColor = theme.palette.primary.main
							e.currentTarget.style.color = theme.palette.common.white
						}}
						onMouseLeave={e => {
							e.currentTarget.style.backgroundColor =
								selectedFilter === 'last30days'
									? theme.palette.primary.main
									: theme.palette.grey[100]
							e.currentTarget.style.color =
								selectedFilter === 'last30days' ? theme.palette.common.white : 'black'
						}}
					>
						Last 30 Days
					</div>
				</div>
			</Box>

			{filtering ? (
				<Typography variant="body2" align="center">
					Loading...
				</Typography>
			) : filteredApplicants.length === 0 ? (
				<Typography variant="body2" align="center" marginTop="40px">
					No applicants found for "{searchQuery || selectedFilter}".
				</Typography>
			) : (
				<Box
					sx={{
						maxHeight: '400px',
						overflowY: 'auto',
						scrollbarWidth: 'none',
						'&::-webkit-scrollbar': { display: 'none' }
					}}
				>
					{filteredApplicantss.map((data, index) => (
						<Card
							key={index}
							style={{
								padding: '10px 0px',
								display: 'flex',
								alignItems: 'center',
								cursor: 'pointer'
							}}
							onClick={() => handleCardClick(data)}
						>
							<div
								style={{
									width: '8px',
									height: '8px',
									borderRadius: '50%',
									backgroundColor: getProgressColor(data.progress),
									marginRight: '10px'
								}}
							></div>
							<CardContent style={{ padding: '12px', flex: 1, width: '100%' }}>
								<Grid container alignItems="center" spacing={2}>
									<Grid item xs={3}>
										<Typography variant="body2" fontWeight="bold">
											{`${data.firstName} ${data.lastName}`}
										</Typography>
									</Grid>
									<Grid item xs={3}>
										<Typography variant="body2" fontWeight="bold" pl={7}>
											{data.totalTimeSpent}
										</Typography>
									</Grid>
									<Grid item xs={3}>
										<Typography variant="body2" fontWeight="bold" pl={8}>
											{data.startTestTime
												? `${new Date(
														data.startTestTime
												  ).toLocaleDateString()} - ${new Date(
														data.startTestTime
												  ).toLocaleTimeString([], {
														hour: '2-digit',
														minute: '2-digit'
												  })}`
												: 'Not Available'}
										</Typography>
									</Grid>
									<Grid
										item
										xs={3}
										style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
									>
										<div
											style={{
												position: 'relative',
												width: '100%',
												maxWidth: '140px',
												height: '6px',
												backgroundColor: '#e0e0e0',
												borderRadius: 10,
												overflow: 'hidden',
												marginLeft: '100px'
											}}
										>
											<div
												style={{
													width: `${data.progress}%`,
													height: '100%',
													backgroundColor: getProgressColor(data.progress),
													transition: 'width 0.3s ease-in-out'
												}}
											></div>
										</div>
										<Typography variant="body2">{data.progress}%</Typography>
									</Grid>
								</Grid>
							</CardContent>
						</Card>
					))}
				</Box>
			)}

			{/* <Dialog open={openDialog} onClose={handleCloseDialog} maxWidth="md" fullWidth>
				<DialogTitle style={{ backgroundColor: 'rgb(125, 110, 241)', height: '50px' }}>
					<Box
						display="flex"
						justifyContent="space-between"
						alignItems="center"
						marginTop="-15px"
					>
						<Typography
							sx={{ fontSize: '22px', color: theme => theme.palette.common.white }}
						>
							{selectedApplicant
								? `${selectedApplicant.firstName} ${selectedApplicant.lastName}`
								: ''}
						</Typography>
						<IconButton onClick={handleCloseDialog}>
							<Close style={{ color: 'white' }} />
						</IconButton>
					</Box>
				</DialogTitle>
				<DialogContent className={classes.noScroll}>
					{selectedApplicant && (
						<Technicalassessment assessId={assessId} applicantData={selectedApplicant} />
					)}
				</DialogContent>
			</Dialog> */}
			<Dialog open={openDialog} onClose={handleCloseDialog} maxWidth="md" fullWidth>
				<DialogTitle
					style={{
						backgroundColor: 'rgb(125, 110, 241)',
						height: '50px',
						padding: '0 16px'
					}}
				>
					<Box
						display="flex"
						alignItems="center"
						justifyContent="space-between"
						width="100%"
					>
						<Typography
							sx={{
								fontSize: '22px',
								color: theme => theme.palette.common.white
							}}
						>
							{selectedApplicant
								? `${selectedApplicant.firstName} ${selectedApplicant.lastName}`
								: ''}
						</Typography>

						<IconButton
							onClick={handleCloseDialog}
							sx={{ color: '#fff', marginRight: '-12px' }}
						>
							<Close />
						</IconButton>
					</Box>
				</DialogTitle>

				<DialogContent className={classes.noScroll}>
					{selectedApplicant && (
						<Technicalassessment assessId={assessId} applicantData={selectedApplicant} />
					)}
				</DialogContent>
			</Dialog>
		</div>
	)
}

export default FlexOne
